export const INCLUDED_FLAG_FIELD = 'includedFlag';
export const DATE_ACQUIRED_FIELD = 'dateAcquired';
export const DATE_INCORPORATED = 'dateIncorporated';
